export default __webpack_public_path__ + "static/media/netflix.69341dfb.png";